import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { Tab, Tabs } from '@occc/ui-design-system';
import { ActivateTransactionViewModel } from '@occc-app/dataAccessLayer/activateTransaction/queries';
import { TransactionViewOfActivateTransaction } from '@occc-app/routes/Transactions/TransactionView/TransactionViewOfActivateTransaction';

import { Navigate, NavLink, Routes, useLocation } from 'react-router-dom';
import { SentryRoute as Route } from '@occc-app/App/sentry';
import TransactionViewFinalizeRequest from '@occc-app/routes/Transactions/TransactionView/TransactionViewFinalizeRequest';
import { useLinks } from './hooks';
import { pageTitle } from './copies';

type TabValue = 'receipt' | 'finalize';

type Props = {
  transaction: ActivateTransactionViewModel;
};

export const MemberTransactionDetailsPage = (props: Props) => {
  const { id, membership } = props.transaction;

  useAppLayoutContextConsumer(useLinks(membership, id));

  const location = useLocation();
  const currentTab: TabValue = location.pathname.includes('/finalize') ? 'finalize' : 'receipt';

  return (
    <Page browserTabTitle={pageTitle} pageHeaderProps={{ title: pageTitle }}>
      <Tabs value={currentTab} color='secondary'>
        <Tab value='receipt' label='Receipt' component={NavLink} to='receipt' />
        <Tab value='finalize' label='Finalize Request' component={NavLink} to='finalize' />
      </Tabs>

      <Routes>
        <Route
          path='/receipt'
          element={<TransactionViewOfActivateTransaction transaction={props.transaction} />}
        />
        <Route
          path='/finalize'
          element={<TransactionViewFinalizeRequest transaction={props.transaction} />}
        />
        <Route path='*' element={<Navigate to='receipt' replace />} />
      </Routes>
    </Page>
  );
};
